import { DateInput, TextInput } from '@core/components/Inputs';
import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React from 'react';
import { opcoesRescisao } from '../ContratoUtils';

const ContratoRescisaoForm = () => {
  const formikContext = useFormikContext();
  const { values, handleChange, handleBlur, errors, touched, submitCount } = formikContext;

  const _errors = {
    data: (submitCount > 0 || touched?.data) && errors?.data,
    motivo: (submitCount > 0 || touched?.motivo) && errors?.motivo,
  };

  return (
    <div className="h-full max-h-full w-full">
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <DateInput
            id="data"
            name="data"
            label="Data da rescisão"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values?.data}
            error={_errors.data}
            helperText={_errors.data}
            touched={!!_errors.data}
            required
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <InputLabel id="motivo" required>
              Motivo
            </InputLabel>
            <Select
              id="motivo"
              name="motivo"
              label="Motivo"
              labelId="motivo"
              value={values?.motivo}
              onChange={handleChange}
              onBlur={handleBlur}
              required
              error={_errors.motivo}
              helperText={_errors.motivo}
              touched={!!_errors.motivo}
            >
              <MenuItem value="FLUXO_CAIXA">{opcoesRescisao.FLUXO_CAIXA}</MenuItem>
              <MenuItem value="NAO_ATENDEU_EXPECTATIVA">{opcoesRescisao.NAO_ATENDEU_EXPECTATIVA}</MenuItem>
              <MenuItem value="NAO_ACOMPANHOU_EVOLUCAO_MERCADO">
                {opcoesRescisao.NAO_ACOMPANHOU_EVOLUCAO_MERCADO}
              </MenuItem>
              <MenuItem value="OPTOU_PELO_CONCORRENTE">{opcoesRescisao.OPTOU_PELO_CONCORRENTE}</MenuItem>
              <MenuItem value="FALENCIA_FECHAMENTO">{opcoesRescisao.FALENCIA_FECHAMENTO}</MenuItem>
              <MenuItem value="PRODUTO_OU_SERVICO_NAO_ATENDE">{opcoesRescisao.PRODUTO_OU_SERVICO_NAO_ATENDE}</MenuItem>
              <MenuItem value="CRISE_FINANCEIRA">{opcoesRescisao.CRISE_FINANCEIRA}</MenuItem>
              <MenuItem value="OUTRO">{opcoesRescisao.OUTRO}</MenuItem>
            </Select>
            <FormHelperText style={{ color: '#f44336' }}>{_errors.motivo || ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <TextInput
            id="comentario"
            name="comentario"
            label="Comentários"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values?.comentario}
            maxLength={500}
            fullWidth
            multiline
            rows={9}
            variant="outlined"
            autoFocus
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default ContratoRescisaoForm;
